export default __webpack_public_path__ + "static/media/Landscape-Weather.1673c85b.png";